export default __webpack_public_path__ + "static/media/calendar-end-icon.9caf314f.svg";